import { Button } from '../../../components/ui/button';
import { GalleryBlock, GiftsBlock, LocationBlock, RsvpBlock, SiteFooter, StoryBlock, renderGalleryByPosition } from '../shared/TemplateBlocks';

export default function DestinationPraiaTemplate(props) {
  const {
    site,
    theme,
    weddingDateLabel,
    daysUntil,
    locationCards,
    availableGifts,
    galleryPosition,
    isTemplatePreview,
    onTemplatePreviewRedirect,
    onOpenRsvp,
    onGiftClick,
    onOpenGallery,
    showGiftSection,
    showRsvpCount,
    confirmedGuests
  } = props;

  const galleryNode = (
    <GalleryBlock
      galleryImages={site.gallery_images}
      headingFont={theme.headingFont}
      titleColor={theme.galleryTitleColor || theme.primaryColor}
      secondaryColor={theme.galleryIconColor || theme.secondaryColor}
      sectionBackground={theme.gallerySectionBackground}
      onOpenGallery={onOpenGallery}
      cardClass="rounded-3xl"
    />
  );

  return (
    <>
      <section className="relative min-h-[68vh] flex items-end px-6 py-10" style={{ background: theme.bannerSectionBackground || '#EEF6FA' }}>
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${theme.heroImage})` }} />
        <div className="absolute inset-0" style={{ background: theme.heroOverlay, opacity: theme.heroOverlayOpacity }} />
        <div className="relative z-10 mx-auto w-full max-w-6xl rounded-3xl border border-white/45 bg-white/70 p-8 backdrop-blur-sm">
          <p className="text-[0.7rem] uppercase tracking-[0.3em]" style={{ color: theme.bannerTextColor || '#4F7A92', fontFamily: theme.bannerTextFont }}>Destination Wedding</p>
          <div className="mt-3 grid gap-4 md:grid-cols-[1.3fr_auto] md:items-end">
            <div>
              <h1 className="text-4xl md:text-6xl" style={{ color: theme.heroTitleColor, fontFamily: theme.bannerTitleFont }}>{site.couple_names}</h1>
              <p className="mt-2 text-base" style={{ color: theme.bannerTextColor || theme.heroDateColor, fontFamily: theme.bannerTextFont }}>{weddingDateLabel}</p>
            </div>
            <Button
              onClick={() => (isTemplatePreview ? onTemplatePreviewRedirect?.() : onOpenRsvp?.())}
              className="h-11 rounded-full px-7"
              style={{ background: theme.confirmButtonBackground, color: theme.confirmButtonText, borderColor: theme.confirmButtonBorder, borderWidth: 1, borderStyle: 'solid' }}
            >
              Confirmar Presença
            </Button>
          </div>
        </div>
      </section>

      <section className="px-6 py-8 bg-[#F7FBFE]">
        <div className="mx-auto max-w-6xl grid gap-4 md:grid-cols-3">
          <div className="rounded-2xl border border-[#D8E8F3] bg-white p-5" style={{ background: theme.locationCardBackground || '#FFFFFF' }}>
            <p className="text-[0.65rem] uppercase tracking-[0.24em]" style={{ color: theme.locationIconColor || theme.locationTitleColor || '#5C8AA7' }}>Cerimônia</p>
            <p className="mt-2 text-lg font-semibold" style={{ color: theme.locationTitleColor || '#1D3F53' }}>{site.ceremony_time || '--:--'}</p>
            <p className="text-sm" style={{ color: theme.locationTextColor || '#48697E' }}>{site.ceremony_location || 'Local a confirmar'}</p>
          </div>
          <div className="rounded-2xl border border-[#D8E8F3] bg-white p-5" style={{ background: theme.locationCardBackground || '#FFFFFF' }}>
            <p className="text-[0.65rem] uppercase tracking-[0.24em]" style={{ color: theme.locationIconColor || theme.locationTitleColor || '#5C8AA7' }}>Recepção</p>
            <p className="mt-2 text-lg font-semibold" style={{ color: theme.locationTitleColor || '#1D3F53' }}>{site.reception_time || '--:--'}</p>
            <p className="text-sm" style={{ color: theme.locationTextColor || '#48697E' }}>{site.reception_location || 'Local a confirmar'}</p>
          </div>
          <div className="rounded-2xl border border-[#D8E8F3] bg-white p-5" style={{ background: theme.locationCardBackground || '#FFFFFF' }}>
            <p className="text-[0.65rem] uppercase tracking-[0.24em]" style={{ color: theme.locationIconColor || theme.locationTitleColor || '#5C8AA7' }}>Contagem</p>
            <p className="mt-2 text-lg font-semibold" style={{ color: theme.locationTitleColor || '#1D3F53' }}>{daysUntil} dias</p>
            <p className="text-sm" style={{ color: theme.locationTextColor || '#48697E' }}>até celebrarmos juntos</p>
          </div>
        </div>
      </section>

      {renderGalleryByPosition(galleryPosition, 'after_hero', galleryNode)}

      <LocationBlock
        locationCards={locationCards}
        headingFont={theme.headingFont}
        titleFont={theme.locationTitleFont || theme.headingFont}
        titleColor={theme.locationTitleColor}

        textColor={theme.locationTextColor}
        textFont={theme.locationTextFont}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.locationSectionBackground || '#F8F6F4'}
        sectionIconColor={theme.locationIconColor || theme.locationTitleColor}
        cardBackground={theme.locationCardBackground}
        cardIconBackground={theme.locationIconColor || theme.locationTitleColor}
        cardTitleColor={theme.locationTitleColor}
        cardLinkColor={theme.locationIconColor || theme.locationTitleColor}
        cardClass="rounded-2xl border border-[#D9E7EF] bg-white/95 shadow-md"
        title="Roteiro do dia"
      />

      <StoryBlock
        title="Nossa História"
        storyText={site.story_text}
        background={theme.storySectionBackground || '#FFFFFF'}
        titleColor={theme.storyTitleColor}
        bodyColor={theme.storyBodyColor}
        titleFont={theme.storyTitleFont}
        bodyFont={theme.storyBodyFont}
      />

      {renderGalleryByPosition(galleryPosition, 'after_story', galleryNode)}
      {renderGalleryByPosition(galleryPosition, 'before_gifts', galleryNode)}

      <GiftsBlock
        gifts={availableGifts}
        headingFont={theme.headingFont}
        theme={theme}
        titleColor={theme.primaryColor}
        textColor={theme.bodyTextColor}
        secondaryColor={theme.secondaryColor}
        onGiftClick={onGiftClick}
        showGiftSection={showGiftSection}
      />

      {renderGalleryByPosition(galleryPosition, 'end', galleryNode)}

      <RsvpBlock
        onOpenRsvp={onOpenRsvp}
        isTemplatePreview={isTemplatePreview}
        onTemplatePreviewRedirect={onTemplatePreviewRedirect}
        primaryColor={theme.primaryColor}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.rsvpSectionBackground}
        buttonBackground={theme.confirmButtonBackground}
        buttonText={theme.confirmButtonText}
        buttonBorder={theme.confirmButtonBorder}
        iconColor={theme.rsvpIconColor || theme.rsvpTextColor || theme.bodyTextColor}
        titleColor={theme.rsvpTextColor || theme.bodyTextColor}
        bodyColor={theme.rsvpTextColor || theme.bodyTextColor}
        countColor={theme.rsvpTextColor || theme.bodyTextColor}
        headingFont={theme.rsvpTitleFont || theme.headingFont}
        bodyFont={theme.rsvpTextFont}
        showRsvpCount={showRsvpCount}
        confirmedGuests={confirmedGuests}
      />

      <SiteFooter coupleNames={site.couple_names} textColor={theme.bodyTextColor} />
    </>
  );
}

